var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"calendar"}},_vm._l((_vm.month_tuples),function(month_tuple){return _c('Month',{staticClass:"month",attrs:{"month":month_tuple.month,"year":month_tuple.year,"tasks":_vm.tasks}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }